import React,{useState,useCallback,useMemo} from 'react';
import {DialogContent,Paper,Dialog,DialogTitle,DialogActions,Button} from '@material-ui/core';
import Draggable from 'react-draggable';
import {paperProps } from '../../../css/muiStyle';
import {SettingsInputAntenna,ExitToApp} from '@material-ui/icons';
import { useStyles } from '../../../css/muiStyle';
import ParamContext from '../../../Contexte';
import { useContext } from 'react';
import {AlertCompo} from "../../../js/components"
import DataTable from "react-data-table-component";
import {customStyles}from '../../../css/datatable-custom'


//Add a new role
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

export default function Adm_usr_histo(props) {
    const classes = useStyles();
    const Gfunc=require('../../../Gfunc')
    const param=useContext(ParamContext);
    const [dis,setDis]=useState('')
    const [open,setOpen]=useState(false)
    const [data,setData]=useState('');
    const [openA, setOpenA] =useState(false);
    const [messageA, setMessageA] =useState('');
    const [severity, setSeverity] =useState('info');
    const service='_usr.php'

    const conditionalRowStyles=[
      { when: row => row.actv===true,
         style: {
               color: "green",
         }
       },
      { when: row => row.actv===false || row.id===dis,
         style: {
               color: 'gray',
         }
       }
    ]

    const handleAlert=(open,severity,message)=>{
        setOpenA(true)
        setSeverity(severity)
        setMessageA(message)
        setTimeout(function(){
          setOpenA(false)
        }, 5000);
      }

    const handleClickOpen = () => { 
      setOpen(true); 
      setDis(false);
      fetch()
    };
    const handleClose = () => { setOpen(false); };

    const fetch= useCallback(async() => {
      const response=await Gfunc.axiosPostAction(service,"getsessions",{userId:props.row.DT_RowId.substr(1)})
      if(response.data.err&&response.data.err!=="-1"){
        handleAlert(true,"error",response.data.err)
      }else{
          Gfunc.axiosResponse(response,()=>{
              if(response.data.jData){
                setData(response.data.jData);
              }
          })
        } 
    },[Gfunc]);
    
    const columns =useMemo(
        () => [   
          {
              name: "OUVERTURE",
              selector:row=> row.open,
              sortable: true,
              minWidth:"130px !important"
          },
          {
              name: "IP",
              selector:row=> row.ip,
              sortable: true,
              minWidth:"130px !important"
          },
          {
              name: "MACHINE",
              selector:row=> row.host,
              sortable: true,
              minWidth:"130px !important"
          },
          {
              name: "FERMETURE",
              selector:row=> row.close,
              sortable: true,
              minWidth:"130px !important"
          }, 
    ],[classes]);
 

  return (
    <div>
      <div id="imprDig" onClick={handleClickOpen}  title="Historique des connexions"><SettingsInputAntenna   className={classes.greenIcon} style={{height:'18px',width:'18px'}}/></div>
      <Dialog 
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            PaperProps={paperProps}
       >
        <DialogTitle className={classes.topDivTitle} id="draggable-dialog-title" >Historique des connexions du <b>{props.row.user}</b></DialogTitle>
        <AlertCompo severity={severity} open={openA} setOpen={setOpenA} message={messageA} dialg={true}/>
        <DialogContent>
        <div id='div-usr-hist'>
            <DataTable 
                    key={Math.floor(Math.random() * (1000 - 1 + 1)) + 1}
                    className="table"
                    persistTableHead
                    columns={columns}
                    data={data}
                    noHeader={true}
                    customStyles={customStyles}
                    defaultSortAsc={true}
                    noDataComponent={param.ErreurData}    
                    highlightOnHover
                    paginationComponentOptions={{ rowsPerPageText: 'Element par page:', rangeSeparatorText: 'sur'}}     
                    conditionalRowStyles = { conditionalRowStyles }          
             />
        </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleClose} color="secondary">FERMER</Button>
        </DialogActions>
      </Dialog>
      </div>
  );
}
